module.exports = __webpack_public_path__ + "static/media/Expertise2.ebe772b8.png";